import { isEmptyValue } from '@/utils/utils';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'preference',
})

export default class Preference extends Vue {

  private accessibilitySettings = {
    is_high_contrast_enabled: false,
    screen_zoom_value: 1,
  };

  private zoomSize = {
    max: 2,
    min: 1,
  };

  private created() {
    const setting = this.$access.getAccessibilitySetting();
    if (!isEmptyValue(setting)) {
      this.accessibilitySettings = this.$access.getAccessibilitySetting();
    }
  }

  private fontUpdate(type: string) {
    let fontSize = this.accessibilitySettings.screen_zoom_value;
    const valueUpdate = 0.1;
    if (type === 'add') {
      if (fontSize < this.zoomSize.max) {
        fontSize += valueUpdate;
      }
    } else if (type === 'subtract') {
      if (fontSize > this.zoomSize.min) {
        fontSize -= valueUpdate;
      }
    }
    this.accessibilitySettings.screen_zoom_value = fontSize;
  }

  private resetPreference() {
    this.accessibilitySettings = {
      is_high_contrast_enabled: false,
      screen_zoom_value: 1,
    };
  }

  private savePreference() {
    this.$access.saveAccessibilitySetting(this.accessibilitySettings);
    window.location.reload();
  }
}
